.layout {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 100vh;
	padding: var(--gap);
	background: var(--bg-color-purple);
}

.card {
	@apply yst-rounded-md;

	background: var(--color-white);
	max-width: 480px;
	width: 100%;
	padding: 48px;
	text-align: center;

	@media screen and (max-width: 600px) {
		padding: 24px;
	}
}

.logo {
	display: block;
	width: 200px;
	margin: 0 auto 24px;
}

.spinnerRow {
	display: flex;
	justify-content: center;
	margin-top: 16px;
}

.message {
	@apply yst-text-base;

	color: var(--color-gray-500);
	margin-top: 8px;
}
